import React from "react";

const ParentInstructionsMessage = ({ onSubmit, onNext }) => {
    const handle = (e) => {
        e.preventDefault();
        onSubmit("acknowledged");
        onNext();
    };

    return (
        <form onSubmit={handle} className="input-form">
            <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: 12 }}>
                <div className="message-bubble assistant-message">
                    <p>
                        <strong>Instructions to parents</strong><br />
                        For the following questions, please answer on behalf of the minor, not yourself.
                    </p>
                </div>

                <button type="submit" className="multiselect-submit-button" style={{ alignSelf: "center" }}>
                    Continue
                </button>
            </div>
        </form>
    );
};

export default ParentInstructionsMessage;
